// extracted by mini-css-extract-plugin
export default {"root":"LargePopup__root--kgeQC","isOpen":"LargePopup__isOpen--mo4vZ"};